import React from 'react';

import ProcoreLogo from 'icons/procore_logo.svg';
import PropTypes from 'prop-types';

export default function CardWrapper({ children, isInactive = false }) {
  return (
    <div
      className={`fw-360 p-16 tw-flex tw-rounded-md tw-border-1 tw-border-solid tw-border-grey-100 ${isInactive ? 'tw-bg-grey-025' : 'tw-bg-white'}`}
    >
      <div className='p-r-12'>
        <div className='bg-procore-orange tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-full'>
          <ProcoreLogo fill='white' height='16px' width='16px' />
        </div>
      </div>
      <div>{children}</div>
    </div>
  );
}

CardWrapper.propTypes = {
  isInactive: PropTypes.bool,
  children: PropTypes.node,
};
